import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LoadingErrorState } from '../components/LoadingErrorState';
import UpdateJobApplication from '../components/forms/UpdateJobApplication';
import toast from 'react-hot-toast';
import { fetchJobApplicationById } from '../hooks/queries';

const ApplicationDetails: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, isFetching, error, refetch } = fetchJobApplicationById({
    id: id || '',
  });

  const { applicant } = data || {};

  return (
    <div className="w-full relative h-full overflow-y-hidden">
      {!isFetching && !error && applicant && (
        <UpdateJobApplication
          currentApplication={applicant}
          onSuccess={() => {
            refetch();
            toast.success('Application updated successfully');
            navigate('/jobs');
          }}
          onError={(error) => toast.error(error.message)}
        />
      )}
      <LoadingErrorState
        isLoading={isFetching}
        isFetching={isFetching}
        error={error}
        refetch={refetch}
        data={applicant}
      />
    </div>
  );
};

export default ApplicationDetails;
